import Job from "./Job";
import JobUpload from "./JobUpload";
import JobAuthen from "./JobAuthen";

export default {
  Job,
  JobUpload,
  JobAuthen,
};
